<template>
  <div class="uk-padding uk-background-muted">
    <div class="uk-container uk-container-large">
      <h1 class="uk-heading-divider uk-text-center specHeading">Meet Our Leaders</h1>
      <h2 class="uk-heading-bullet uk-text-center specHeading uk-text-muted"><span>Office of the President</span></h2>
      <div class="uk-child-width-1-1@m " uk-grid>
        <div></div>
        <div>
          <div uk-grid>
            <div class="uk-width-1-5@m uk-width-1-3@l "></div>
            <div class="uk-width-3-5@m uk-width-1-3@l">
              <div class="uk-card uk-card-default " style="border-radius: 15px">
                <div class="uk-card-media-top">
                  <img src="../assets/DrLincolnEdwardsNCUPrsident.jpg" alt="" style="border-radius: 15px; width: 100%;">
                </div>
                <div class="uk-card-body">
                  <h4 class="specHeading">Professor Lincoln Edwards</h4>
                  <p class=" uk-text-muted specHeading">President</p>
                  <a class="uk-button uk-button-secondary uk-text-capitalize uk-align-right@l" href="#lincoln" uk-toggle>View Bio
                    <span uk-icon="arrow-right"></span>
                  </a>
                </div>
              </div>
            </div>
            <div class="uk-width-1-5@m uk-width-1-3@l"></div>
          </div>
        </div>
        <div></div>
      </div>

      <h2 class="uk-heading-bullet uk-text-center specHeading uk-text-muted"><span>Vice Presidents</span></h2>


      <div class="uk-child-width-1-2@s uk-child-width-1-4@l uk-padding-small" uk-grid>

<!--        <div>
          <div class="uk-card uk-card-default" style="border-radius: 15px">
            <div class="uk-card-media-top">
              <img src="/vQuarrie.png" alt="" style="border-radius: 15px">
            </div>
            <div class="uk-card-body">
              <h5 class="specHeading">Dr. Vivienne L. Quarrie </h5>
              <p class=" uk-text-muted specHeading">Vice President of Academic Administration</p>

&lt;!&ndash;              <a class="uk-button uk-button-secondary uk-text-capitalize uk-align-right@xl" href="#quarrie" uk-toggle>View Bio
                <span class="uk-visible@m" uk-icon="arrow-right"></span>
              </a>&ndash;&gt;
            </div>
          </div>
        </div>-->

<!--        <div>
          <div class="uk-card uk-card-default" style="border-radius: 15px">
            <div class="uk-card-media-top">
              <img src="/tWilson.png" alt="" style="border-radius: 15px">
            </div>
            <div class="uk-card-body">
              <h5 class="specHeading">Dr. Trescott Wilson</h5>
              <p class=" uk-text-muted specHeading">Vice President of Finance</p>
&lt;!&ndash;              <a class="uk-button uk-button-secondary uk-text-capitalize uk-align-right@xl" href="#trescott" uk-toggle>View Bio
                <span class="uk-visible@m" uk-icon="arrow-right"></span>
              </a>&ndash;&gt;
            </div>

          </div>
        </div>-->

        <div>
          <div class="uk-card uk-card-default" style="border-radius: 15px">
            <div class="uk-card-media-top">
              <img src="/cSmith.png" alt="" style="border-radius: 15px">
            </div>
            <div class="uk-card-body">
              <h5 class="specHeading">Mrs. Carolyn Smith</h5>
              <p class=" uk-text-muted specHeading">Vice President of Student Affairs</p>
<!--              <a class="uk-button uk-button-secondary uk-text-capitalize uk-align-right@xl" href="#cleghorne" uk-toggle>View Bio
                <span class="uk-visible@m" uk-icon="arrow-right"></span>
              </a>-->

            </div>

          </div>
        </div>

        <div>
          <div class="uk-card uk-card-default" style="border-radius: 15px">
            <div class="uk-card-media-top">
              <img src="/mReid.png" alt="" style="border-radius: 15px">
            </div>
            <div class="uk-card-body">
              <h5 class="specHeading">Dr. Michael Reid</h5>
              <p class=" uk-text-muted specHeading">Chief Information Officer</p>
<!--              <a class="uk-button uk-button-secondary uk-text-capitalize uk-align-right@xl" href="#mreid" uk-toggle>View Bio
                <span class="uk-visible@m" uk-icon="arrow-right"></span>
              </a>-->
            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-default" style="border-radius: 15px">
            <div class="uk-card-media-top">
              <img src="/CharleneSharpe.png" alt="" style="border-radius: 15px">
            </div>
            <div class="uk-card-body">
              <h5 class="specHeading">Dr. Charlene Sharpe</h5>
              <p class=" uk-text-muted specHeading">Associate Provost, University Administration</p>
<!--              <a class="uk-button uk-button-secondary uk-text-capitalize uk-align-right@xl" href="#mreid" uk-toggle>View Bio
                <span class="uk-visible@m" uk-icon="arrow-right"></span>
              </a>-->
            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-default" style="border-radius: 15px">
            <div class="uk-card-media-top">
              <img src="/DamionMitchell.png" alt="" style="border-radius: 15px">
            </div>
            <div class="uk-card-body">
              <h5 class="specHeading">Dr. Damion Mitchell</h5>
              <p class=" uk-text-muted specHeading">Assistant Provost,  Digital Education</p>
<!--              <a class="uk-button uk-button-secondary uk-text-capitalize uk-align-right@xl" href="#mreid" uk-toggle>View Bio
                <span class="uk-visible@m" uk-icon="arrow-right"></span>
              </a>-->
            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-default" style="border-radius: 15px">
            <div class="uk-card-media-top">
              <img src="/NanibalaPaul.png" alt="" style="border-radius: 15px">
            </div>
            <div class="uk-card-body">
              <h5 class="specHeading">Dr. Nanibala Paul</h5>
              <p class=" uk-text-muted specHeading">Associate Provost, Academic Affairs</p>
<!--              <a class="uk-button uk-button-secondary uk-text-capitalize uk-align-right@xl" href="#mreid" uk-toggle>View Bio
                <span class="uk-visible@m" uk-icon="arrow-right"></span>
              </a>-->
            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-default" style="border-radius: 15px">
            <div class="uk-card-media-top">
              <img src="/CarolBentwright.png" alt="" style="border-radius: 15px">
            </div>
            <div class="uk-card-body">
              <h5 class="specHeading">Carol Bent-Wright</h5>
              <p class=" uk-text-muted specHeading">Director, Human Resource</p>
<!--              <a class="uk-button uk-button-secondary uk-text-capitalize uk-align-right@xl" href="#mreid" uk-toggle>View Bio
                <span class="uk-visible@m" uk-icon="arrow-right"></span>
              </a>-->
            </div>
          </div>
        </div>

<!--        <div>
          <div class="uk-card uk-card-default" style="border-radius: 15px">
            <div class="uk-card-media-top">
              <img src="/eMalcolm.png" alt="" style="border-radius: 15px">
            </div>
            <div class="uk-card-body">
              <h5 class="specHeading">Mr. Errol Malcolm</h5>
              <p class=" uk-text-muted specHeading">Vice President of Industries</p>
&lt;!&ndash;              <a class="uk-button uk-button-secondary uk-text-capitalize uk-align-right@xl" href="#malcolm" uk-toggle>View Bio
                <span class="uk-visible@m" uk-icon="arrow-right"></span>
              </a>&ndash;&gt;
            </div>

          </div>
        </div>-->

      </div>

      <!--<h2 class="uk-heading-bullet uk-text-center specHeading uk-text-muted"><span>Associate Vice President</span></h2>
      <div class="uk-child-width-1-5@m" uk-grid>
        <div>
          <div class="uk-card uk-card-default">
            <div class="uk-card-media-top">
              <img src="../../../assets/LanaBrown.png" alt="">
            </div>
            <div class="uk-card-body">
              <h4 class="specHeading">Mrs Lana Brown </h4>
              <p class=" uk-text-muted specHeading">Finance</p>
              <button class="uk-button uk-button-secondary">View Bio</button>
            </div>
          </div>
        </div>
        <div>
          <div class="uk-card uk-card-default">
            <div class="uk-card-media-top">
              <img src="../../../assets/nadine.png" alt="">
            </div>
            <div class="uk-card-body">
              <h4 class="specHeading">Dr. Vincent Peterkin </h4>
              <p class=" uk-text-muted specHeading">Academic Administration (Undergraduate)</p>
              <button class="uk-button uk-button-secondary">View Bio</button>
            </div>

          </div>
        </div>
        <div>
          <div class="uk-card uk-card-default">
            <div class="uk-card-media-top">
              <img src="../../../assets/nadine.png" alt="">
            </div>
            <div class="uk-card-body">
              <h4 class="specHeading">Dr. Vivienne Quarrie </h4>
              <p class=" uk-text-muted specHeading">Academic Administration (Graduate)</p>
              <button class="uk-button uk-button-secondary">View Bio</button>
            </div>

          </div>
        </div>

        <div>
          <div class="uk-card uk-card-default">
            <div class="uk-card-media-top">
              <img src="../../../assets/bignal.png" alt="">
            </div>
            <div class="uk-card-body">
              <h4 class="specHeading">Dr. Bylton Clarke </h4>
              <p class=" uk-text-muted specHeading">Office of the Provost</p>
              <button class="uk-button uk-button-secondary">View Bio</button>
            </div>

          </div>
        </div>
        <div>
          <div class="uk-card uk-card-default">
            <div class="uk-card-media-top">
              <img src="../../../assets/cleghorne.png" alt="">
            </div>
            <div class="uk-card-body">
              <h4 class="specHeading">Mr. Sefton Brown </h4>
              <p class=" uk-text-muted specHeading">Student Services</p>
              <button class="uk-button uk-button-secondary">View Bio</button>
            </div>

          </div>
        </div>
        <div>
          <div class="uk-card uk-card-default">
            <div class="uk-card-media-top">
              <img src="../../../assets/president.jpg" alt="">
            </div>
            <div class="uk-card-body">
              <h4 class="specHeading">Mrs. Carolyn Smith </h4>
              <p class=" uk-text-muted specHeading">Student Services</p>
              <button class="uk-button uk-button-secondary">View Bio</button>
            </div>

          </div>
        </div>
      </div>-->

    </div>


    <div id="lincoln" class="uk-modal-full" uk-modal>
      <div class="uk-modal-dialog">
        <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
        <div class="uk-grid-collapse uk-child-width-1-2@l " uk-grid>
          <div class="uk-background-cover uk-visible@l" style="background-image: url('/LincolnEdwards.jpg');" uk-height-viewport></div>
          <div class="uk-padding-large">
            <article class="uk-article">

              <h1 class="uk-article-title"><a class="uk-link-reset" >Lincoln P. Edwards, DDS, PhD</a></h1>

              <p class="uk-article-meta">Title: President, Northern Caribbean University </p>
              <p class="uk-article-meta">Education: D.D.S, Loma Linda University, Loma Linda CA, Postdoctoral Fellow, Case
                Western Reserve University, Cleveland OH , Ph.D., Loma Linda University, Loma Linda CA
              </p>

              <p >
                Professor Lincoln Edwards serves as President of Northern Caribbean University (NCU) in Mandeville
                Jamaica. He is a graduate of the University of the West Indies (UWI), and Loma Linda
                University (LLU) and holds a Bachelor’s degree in Chemistry (Special), a PhD in Pharmacology,
                and a Doctor of Dental Surgery (DDS) degree.
                <br><br>
                Professor Edwards currently serves on three American Dental Association Test Construction
                Committees and is Chair of the American Dental Education Association section on Oral
                Diagnosis and Oral Medicine. He has previously served as an Assistant Professor in the School
                of Medicine, and an Associate Professor in the School of Dentistry at Loma Linda University. 
                Dr. Edwards has also served as an Associate Professor at the University of Texas Health
                Sciences Center, School of Dentistry in Houston.
              </p>

              <p>
                Professor Edwards is a long standing member of the Network of Minority Health Research
                Investigators (NMRI) and served as Chair of the 15 th Anniversary Planning Committee. The
                NMRI serves as an advisory body to the National Institute of Diabetes, Digestive and Kidney
                Diseases (NIDDK). He is a member of several editorial and accreditation-readiness boards. Dr.
                Edwards has an established career in the sciences and has won several national awards including
                the NIDDK Basic Science Poster Award and Oral Presentation Award. He is the first person to
                have won this award twice.
              </p>
              <p>
                His life and work has impacted many across the globe. He has spearheaded several dental
                missions in the United States and Jamaica and has over the past six years helped hundreds of
                individuals to access free dental services in the parishes of Kingston, St. Catherine, Clarendon
                and Manchester.
              </p>
              <p>
                Professor Edwards is a published researcher in the area of diabetes and hypertension with over fifty
                peer reviewed papers and abstracts and has obtained two National Institutes of Health grants in
                the United States of America. Amidst his hectic professional and philanthropic schedule, he still
                finds the time to work for the Lord and is an experienced Lay Preacher and has served in various
                capacities within the Seventh-day Adventist Church.
              </p>
              <p>
               Professor Edwards is married to Sandra Taylor, and together they have three children, Alex, Ross-
                Andre and Alexa.  When he is not spending time with family or doing research on how to
                improve the health and wellbeing of others, he enjoys a friendly game of soccer.
              </p>


            </article>
          </div>
        </div>
      </div>
    </div>
    <!--<div id="gyles" class="uk-modal-full" uk-modal>
      <div class="uk-modal-dialog">
        <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
        <div class="uk-grid-collapse uk-child-width-1-2@l" uk-grid>
          <div class="uk-background-cover  uk-visible@l" style="background-image: url('../../../../static/PaulGyles.png');" uk-height-viewport></div>
          <div class="uk-padding-large">
            <article class="uk-article">

              <h1 class="uk-article-title"><a class="uk-link-reset" >Professor Paul Gyles, PhD</a></h1>

              <p class="uk-article-meta">Title: Provost, Northern Caribbean University </p>
              <p class="uk-article-meta">Education: Molecular Cell Biology and Endocrinology, 1992, Howard University, Washington D.C</p>

              <p class="">
                Paul Aaron Gyles was born in Orangefield, St. Catherine, Jamaica and his love for science
                was evident from his early childhood days. His dream became a reality and he has been a
                scientist since graduating from Howard University in 1992. He has done extensive work on
                research projects related to cancers and pathogenic microbes affecting humans. His
                expertise is in Cancer Biology, Food Microbiology and Endocrinology.
              </p>

              <p>
                Professor Gyles has published many articles in peer-reviewed journals and has made
                several oral presentations at conferences both locally and internationally. He has
                collaborated with his colleagues, Dr Judith Bailey Penrod and Mrs Patrice Williams Gordon,
                on the properties of sorrel and demonstrated that drink made from this plant has
                anticancer properties. Professor Gyles is currently doing further research on sorrel to
                examine its toxicity properties on cancer tissues. His scientific and entrepreneurial skills
                have combined well, leading to the ownership of a small pharmaceutical company which
                manufactures two products that are sold in pharmacies. He formerly supervised the
                Office of Graduate Studies and Research at Northern Caribbean University and has now
                been elected as Provost of the institution.
              </p>


            </article>
          </div>
        </div>
      </div>
    </div>-->
    <div id="malcolm" class="uk-modal-full" uk-modal>
      <div class="uk-modal-dialog">
        <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
        <div class="uk-grid-collapse uk-child-width-1-2@l " uk-grid>
          <div class="uk-background-cover  uk-visible@l" style="background-image: url('/eMalcolm.png');" uk-height-viewport></div>
          <div class="uk-padding-large">
            <article class="uk-article">

              <h1 class="uk-article-title"><a class="uk-link-reset" >Errol Malcolm, MBA</a></h1>

              <p class="uk-article-meta">Title: Vice President of Finance & Industries </p>
              <p class="uk-article-meta">Education: Master of Business Administration, Barry University, Miami, Florida,</p>

              <p>
                Mr Errol Malcolm was appointed as the Vice President of Industries of
                Northern Caribbean University in late August 2022. Under his stewardship are:  Facilities Management and Purchasing: Repairs and Maintenance,
                 Custodial Services, Campus Upkeep, Woodshop, University Stores and
                Transportation.
              </p>

              <p>
                At NCU, Mr. Malcolm has been mandated with the task of revolutionizing the operations of the
                University, restoring the financial strength and recovery of the institution’s revenue points and
                streamlining efficiencies throughout the organization with respect to areas under his
                responsibility.
              </p>
              <p>
                Prior to his appointment, Mr. Malcolm was employed to the Trelawny Parish Council for twelve
                (12) years (2004-2016) on a merit basis. He has had a solid history of producing results within a
                limited budget and has built and successfully managed a multi-disciplined staff of 50 from
                different functional business domains within the organization. These employees of which he has
                direct supervision includes both technical and administrative personnel in management and
                clerical roles.
              </p>
              <p>
                In the management roles he has occupied over the past 20+ years, he has transformed
                theoretical concepts into practical workable solutions which have seen several enterprises
                benefit from cost savings and increases in the efficiency of business operations. Mr. Malcolm
                has consistently accomplished performance targets and exceeded corporate goals throughout
                his professional career.
              </p>
              <p>
                He is a graduate of Barry University, Miami, Florida, where he holds a Master’s Degree in
                Business Administration. In addition, he has a first degree in Law (Hon.) and another in
                Accounting from the University of Technology and Northern Caribbean University respectively.
                Mr. Malcolm’s academic knowledge gained from these institutions have provided him with the
                capability to be innovative and engage in strategic thinking to solve a wide range of complex
                business problems and scenarios.
              </p>
              <p>
                Having had a rich working history in Finance, he demonstrates substantial experience in all
                aspects of Financial Management, Banking, Accounting, Auditing, Revenue Generation, Credit
                Appraisal, Debt Management, Collection and Procurement. Though Mr. Malcolm has worked in
                various management positions, he still maintains the capacity to perform hands on technical
                tasks from which he ensures that his direct line staff benefits through mentoring and coaching
                opportunities. His skills also span the areas of business development, project management,
                human relations, property management, licensing and international trade.
              </p>
              <p>
                Mr. Malcolm, a devout Adventist member has served in various ministries of his local church,
                which includes his current role as an elder. He is married and has four adult children.
              </p>


            </article>
          </div>
        </div>
      </div>
    </div>
    <div id="trescott" class="uk-modal-full" uk-modal>
      <div class="uk-modal-dialog">
        <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
        <div class="uk-grid-collapse uk-child-width-1-2@l " uk-grid>
          <div class="uk-background-cover  uk-visible@l" style="background-image: url('/tWilson.png');" uk-height-viewport></div>
          <div class="uk-padding-large">
            <article class="uk-article">

              <h1 class="uk-article-title"><a class="uk-link-reset" >Trescott Wilson Dr, </a></h1>

              <p class="uk-article-meta">Title: Vice President of Finance, DBA, MBA,</p>
              <p class="uk-article-meta">Education: Master of Business Administration, Alabama A & M University
              </p>

              <p class="">
                Dr Trescot Wilson has served for more than 30 years at the senior management level in higher education prior
                to assuming the position of Vice President for Finance and Facilities at Northern Caribbean University (NCU).
              </p>

              <p>
                His professional experience includes Acting Vice President for Academics and Student Services at Bermuda
                College as well as Dean for the Division of Business Administration and Hospitality at this institution. He
                served previously at NCU in the positions of Dean for College of Professional & Continuing Education and
                Human Services; Dean of the College of Business and Information Science; and Director of the Master of
                Business Administration Programme. In addition to his administrative roles, Dr Wilson had been an
                academician at Bermuda College (Professor in the Division of Business Administration & Hospitality) as well
                as at Northern Caribbean University (Chair & Professor in the Division of Business Administration and
                Industry).
              </p>
              <p>
                Graduating from West Indies College (the forerunner of NCU) in 1978, Dr. Wilson subsequently obtained the
                Doctor of Business Administration degree from Nova Southeastern University as well as the Master of Business
                Administration degree from Alabama A & M University. He completed post-graduate studies in Accounting
                Information System from University of Georgia; and is an Associate of the International Association of
                Bookkeepers based in the United Kingdom.
              </p>

              <ul class="uk-list uk-list-divider">
                Dr Wilson has written and presented on various subjects including:
                <li class="uk-text-small">
                  The Influence of Motivation and Job Satisfaction on Human Behaviour in a Work-related Situation, Imprint,
                  March 1998.
                </li>
                <li class="uk-text-small">
                  A Framework for Understanding the Dimensions of Organizational Commitment, Caribbean Labor Journal, July
                  1996.
                </li>
                <li class="uk-text-small">
                  An Analysis of Organizational Commitment Among Private Sector Workers in Jamaica, Dissertation, 1996.
                </li>
                <li class="uk-text-small">
                  Marketing Strategies to Enhance Continuing Education Delivery
                  Presentation to the Spring Conference, Association of Continuing Higher Education, Cape Cod Bay, Brewster,
                  Massachusetts, (April 23-25, 2003)
                </li>
                <li class="uk-text-small">
                  CARICOM Single Market and Economy – Organizational Responsibility
                  Presentation to the Internal and External Affairs Committee of Parliament, Gordon House, Jamaica. (July 2002)
                </li>
                <li class="uk-text-small">
                  Foreign Trade—Meeting the Challenges...Grasping the Response
                  Organized and facilitated a joint forum with The Ministry of Foreign Affairs and Foreign Trade and The
                  College of Professional & Continuing Education, Northern Caribbean University. Presenter: “The Way
                  Forward.” (April 2002)
                </li>
                <li  class="uk-text-small">
                  Standards For National Development
                  Organized and facilitated a joint forum with The National Council on Technical and Vocational Education and
                  Training (NCTVET), The Jamaica Bureau of Standards, (JBS) and The College of Professional and Continuing
                  Education. (May 2001)
                </li>
              </ul>



            </article>
          </div>
        </div>
      </div>
    </div>
    <div id="cleghorne" class="uk-modal-full" uk-modal>
      <div class="uk-modal-dialog">
        <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
        <div class="uk-grid-collapse uk-child-width-1-2@l " uk-grid>
          <div class="uk-background-cover uk-visible@l" style="background-image: url('/cleghorne.png'); margin-top: 0" uk-height-viewport></div>
          <div class="uk-padding-large">
            <article class="uk-article">

              <h1 class="uk-article-title"><a class="uk-link-reset" > Newton Cleghorne, DMin</a></h1>

              <p class="uk-article-meta">Title: Vice President Student Services, Northern Caribbean University </p>
              <p class="uk-article-meta">Education: Doctor of Ministry, Andrews University, Berrien Springs, Michigan
              </p>

              <p class="">
                Dr. Newton U. Cleghorne is an ordained minister of the Seventh-day Adventist Church
                and has been serving the cause of Christ for the past thirty-nine years. He hails from the north
                coast town of Duncans in the parish of Trelawny, and is a second generation of Seventh-day
                Adventists.
              </p>

              <p>
                Dr. Cleghorne is a distinguished product of Seventh-day Adventist Christian Education.
                He attended and graduated from Harrison Memorial High School, Montego Bay; West Indies
                College (now NCU), where he earned a Bachelor of Arts degree in Theology. His graduate and
                post-graduate degrees are from Andrews University, Berrien Springs, Michigan from which he
                holds a Master of Arts in Religion and a Doctor of Ministry degree with an emphasis in Youth
                Ministry.
              </p>
              <p>
                Dr. Cleghorne served as Pastor, Evangelist, Elementary and High School Teacher and
                youth ministries specialist in West Jamaica Conference for 11 years before migrating to the
                United States of America. In 1989, he was called to serve the Northeastern Conference,
                headquartered in Jamaica, Queens, N Y City as Senior Pastor of the Sharon, then City
                Tabernacle SDA Churches before being called to serve as the Youth Ministries Director, a
                position he held with distinction for ten years.
              </p>
              <p>
                In June of 2006, Dr. Cleghorne received and accepted a call to serve as the Dean of the
                School of Religion and Theology, a position he assumed since August 1, 2006. During this time,
                Dr. Cleghorne served as Acting Senior Pastor of the Seventh-day Adventist Church at Northern
                Caribbean University for four months (February to May 2016). On September 1, 2016, Dr.
                Cleghorne was asked by the Northern Caribbean University Board of Trustees to serve as the
                Vice President for Student Services, a position in which he continues to serve.
              </p>
              <p>
                As an international evangelist, Dr. Cleghorne has seen over four thousand precious souls
                come to Jesus and recently in the Now is the Time Evangelist conducted in Kingston between
                June and July this year, 2017, over 500 and counting precious souls were baptized.
              </p>
              <p>
                Dr. Cleghorne’s wife, Wayne Elizabeth of over thirty-seven years, is a Registered Nurse,
                Certified Science Teacher, Writer, Publisher and Concert-recording Artist and holds the Doctor
                of Philosophy (PhD) degree in Leadership Education from Andrews University.
                <br><br>
                As a part of his philosophy for ministry, Dr Cleghorne strongly believes that a church
                without youth will die; for the youth are the church’s greatest asset and its fondest hope.
                Therefore, we must identify, train, mentor, position and liberate them into effective service for
                God and country in readiness for the imminent return of our Lord and Saviour, Jesus Christ.
              </p>
            </article>
          </div>
        </div>
      </div>
    </div>
    <div id="quarrie" class="uk-modal-full" uk-modal>
      <div class="uk-modal-dialog">
        <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
        <div class="uk-grid-collapse uk-child-width-1-2@l " uk-grid>
          <div class="uk-background-cover uk-visible@l" style="background-image: url('/vQuarrie.png'); margin-top: 0" uk-height-viewport></div>
          <div class="uk-padding-large">
            <article class="uk-article">

              <h1 class="uk-article-title"><a class="uk-link-reset" > Vivienne L. Quarrie, PhD</a></h1>

              <p class="uk-article-meta">Title: Vice President Academic Administration, Northern Caribbean University </p>
              <p class="uk-article-meta">Education: Phd in Higher Educational Administration and Leadership
              </p>

              <p class="">
                Vivienne Lyn Quarrie, a Jamaican, has served the Seventh-day
                Adventist Church in numerous capacities, including those of
                educator and Department Chair at both the secondary and
                tertiary levels; and as Associate Director in the Education
                Department of West Indies Union Conference (now Jamaica
                Union Conference), providing oversight for the respective
                Directors in the Islands of the Bahamas, the Cayman Islands,
                Jamaica, and the Turks and Caicos Islands. She has been
                formally trained in the areas of Education, English, Religion,
                History, Psychology, and Educational Administration and
                Leadership, and is an Associate Professor who currently serves
                as an Associate Vice-President for Academic Administration, with responsibilities for
                Graduate Studies and Research at Northern Caribbean University.
              </p>

              <p>
                She has received numerous scholarships, honours, and awards both as a student and as a
                professional, with those from Northern Caribbean University being the “Theology Student of
                the Year Award” in 1991, a “Distinguished Faculty Award for Teaching” for the 2002-2003
                Academic Year, a “Special Award for Assistance in the Cultural Refinement of Students”
                from the Department of Student Development, and a “Service Excellence Award” received in
                2016.
              </p>
              <p>
                Her research interests include leadership in higher education, and she has presented on this
                subject at conferences and other fora both locally and internationally. She has recently co-
                published three articles in the International Journal of Emergency Mental Health and Human
                Resilience (2015), in the Journal of Advanced Research in Public Policy and Administration
                (2015), and in the Journal of Advanced Research in Psychology and Psychotherapy (2016),
                respectively.
              </p>
              <p>
                She has been a member of the Jamaica Literacy Association, the International Literacy
                Association, the Association for Supervision and Curriculum Development, and Pi Lambda
                Theta; and has served as a member of the Executive Committee of the West Indies Union
                Conference, continues to serve as a member of the Board of Education of the Jamaica
                Union Conference of Seventh-day Adventists, and currently represents the Inter-American
                Division on the Executive Committee of the General Conference of Seventh-day Adventists.
              </p>

            </article>
          </div>
        </div>
      </div>
    </div>
    <div id="mreid" class="uk-modal-full" uk-modal>
      <div class="uk-modal-dialog">
        <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
        <div class="uk-grid-collapse uk-child-width-1-2@l " uk-grid>
          <div class="uk-background-cover uk-visible@l" style="background-image: url('/mReid.png'); margin-top: 0" uk-height-viewport></div>
          <div class="uk-padding-large">
            <article class="uk-article">

              <h1 class="uk-article-title"><a class="uk-link-reset" >Dr. Michael Reid</a></h1>

              <p class="uk-article-meta">Title: Chief Information Officer, Northern Caribbean University </p>
              <p class="uk-article-meta">Education:  PhD in Information Systems, Nova Southeastern
                University
              </p>

              <p class="">
                Dr. Reid holds a doctorate degree in Information Systems from Nova Southeastern
                University and a Master’s degree in Software Engineering from Andrews
                University. With more than 15 years of progressive management experience in
                various large organizations within the United States and the Caribbean, Dr. Reid
                offers a distinguished career earmarked by accomplishments in leading and
                directing Information Technology operations across broad disciplines in academia
                and healthcare. Some of these areas include: software engineering, project
                management, database management, decision support and business intelligence
                systems, strategic planning, teaching and research, and technology
                implementation.
              </p>



            </article>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "meetourleaders"
  }
</script>

<style scoped>

</style>
